import React from 'react';
// import cn from 'classnames';
// import Image from 'next/image';

// import { AnchorArrow } from 'react-scale/components';

import DropdownItem from '../../DropdownItem';
import { dropdownItems } from '../../Content';

// import styles from '../../AnnouncementBanner/AnnouncementBanner.module.css';

const ProductsDropdown = ({ theme, dropdown, navResponsive }) => (
  <div>
    <div
      className="flex items-start gap-10 pt-10 pb-12 xl:gap-16 px-14"
      data-first-dropdown-section
    >
      <div>
        <h4 className="inline-block mb-6 text-overtitle-sm text-gradient">
          {dropdownItems[dropdown].annotate.title}
        </h4>
        <ul className="grid grid-cols-none gap-y-8">
          {dropdownItems[dropdown].annotate.content.map(item => (
            <DropdownItem
              key={item.title}
              href={item.href}
              icon={item.icon}
              title={item.title}
              text={item.text}
              colors={theme.dropdown.items}
              itemType={item.type}
              navResponsive={navResponsive}
            />
          ))}
        </ul>
      </div>
      <div className="grid grid-cols-none gap-y-7">
        {dropdownItems[dropdown].others.map(item => (
          <div>
            {item.title && (
              <h4 className="inline-block mb-6 text-overtitle-sm text-gradient">{item.title}</h4>
            )}
            <ul>
              <DropdownItem
                key={item.content.title}
                href={item.content.href}
                icon={item.content.icon}
                title={item.content.title}
                text={item.content.text}
                colors={theme.dropdown.items}
                itemType={item.content.type}
                navResponsive={navResponsive}
              />
            </ul>
          </div>
        ))}
        {dropdownItems[dropdown].othersSecondColumn && (
          <div className="grid grid-cols-none gap-y-7">
            {dropdownItems[dropdown].othersSecondColumn.map(item => (
              <div>
                {item.title && (
                  <h4 className="inline-block mb-6 text-overtitle-sm text-gradient">
                    {item.title}
                  </h4>
                )}
                <ul>
                  <DropdownItem
                    key={item.content.title}
                    href={item.content.href}
                    icon={item.content.icon}
                    title={item.content.title}
                    text={item.content.text}
                    colors={theme.dropdown.items}
                    itemType={item.content.type}
                    navResponsive={navResponsive}
                  />
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
    {/* {!navResponsive && (
                <div className={cn(theme.rapid.gradient ? styles.gradientRapid : null, 'relative')}>
                  <div className={theme.rapid.background}>
                    <div className="flex items-center justify-center py-6">
                      <div className="relative flex items-center">
                        <div className="flex items-center justify-center h-full pr-2">
                          <Image
                            src="/static/images/pages/rapid/rapid-logo.svg"
                            width="27"
                            height="40"
                            layout="fixed"
                            priority
                          />
                          <p className="ml-2 text-base font-aeonik text-gradient">Scale Rapid</p>
                        </div>
                        <p className={`${theme.rapid.text} text-sm mr-2 lg:whitespace-nowrap`}>
                          The fastest way to production-quality labels.
                        </p>
                        <span className="text-sm">
                          <AnchorArrow
                            text='Learn More'
                            href='/rapid'
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
  </div>
);

ProductsDropdown.defaultProps = {
  dropdown: 'products',
  navResponsive: false
};

export default ProductsDropdown;
